import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { CountryInfo } from '../../types';

const getAllCountriesAPI = () => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetAllCountries`,
    method: 'get',
  });
};

export type AllCountriesResponse = CountryInfo[];

export const fetchAllCountriesList = async (): Promise<AllCountriesResponse> => {
  const response: AxiosResponse<AllCountriesResponse> = await getAllCountriesAPI();
  return response.data;
};
